import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-grafica-radar',
  templateUrl: './grafica-radar.component.html',
  styleUrls: ['./grafica-radar.component.css']
})
export class GraficaRadarComponent implements OnChanges {

  @Input() public radarChartLabels : string[] = [];
  @Input() public radarChartData : any = [];

  constructor() {}

  ngOnChanges() {
    this.getDataRadarInputs();
  }

  private async getDataRadarInputs() {
    await this.radarChartData;
    await this.radarChartLabels;
  }
 
  // Radar
  public radarChartType : string = 'radar';

  // events
  public chartClicked(e:any):void {
    //console.log(e);
  }
 
  public chartHovered(e:any):void {
    //console.log(e);
  }

}
